import { ICalendarFilter } from "../../../entities/calendar";

const ARRAY_FIELDS: (keyof Pick<ICalendarFilter, 'tgAccountIds' | 'userIds' | 'studentIds' | 'tagIds'>)[] = [
    'tgAccountIds',
    'userIds',
    'studentIds',
    'tagIds',
]

const getBoolean = (searchParams: URLSearchParams, field: string): boolean => {
    return searchParams.get(field) !== 'false'
}

export const getCalendarFilterFromSearchParams = (searchParams: URLSearchParams): ICalendarFilter => {
    return {
        tgAccountIds: searchParams.getAll('tgAccountIds'),
        userIds: searchParams.getAll('userIds'),
        studentIds: searchParams.getAll('studentIds'),
        tagIds: searchParams.getAll('tagIds'),
        includeCancelled: getBoolean(searchParams, 'includeCancelled'),
        includeRescheduled: getBoolean(searchParams, 'includeRescheduled'),
    }
}

export const getSearchParamsFromCalendarFilter = (filter: ICalendarFilter): URLSearchParams => {
    const searchParams = new URLSearchParams()

    ARRAY_FIELDS.forEach(field => {
        filter[field].forEach(id => searchParams.append(field, id))
    })

    searchParams.set('includeCancelled', String(filter.includeCancelled))
    searchParams.set('includeRescheduled', String(filter.includeRescheduled))

    return searchParams
}

export const isCalendarFilterComplete = (filter: ICalendarFilter): boolean => {
    return Boolean(
        filter.tgAccountIds.length &&
        filter.userIds.length &&
        filter.studentIds.length
    )
}
